import { useCountDown } from "ahooks";
import classNames from "classnames";
import { CSSProperties, type HTMLAttributes } from "react";
import styles from "./countDown.module.less";

export interface CountDownProps extends HTMLAttributes<HTMLDivElement> {
  preffix?: string;
  targetDate: number | string | Date;
  /**倒计时剩余几天时才开始展示 */
  startShowDays: number;
  /** 数字背景色*/
  bg: string;
  /** 数字背景方框大小*/
  bgSize: number | string;
  /** 时间数字文字颜色*/
  numberColor: string;
  /** 时间数字文字大小*/
  numberSize: number | string;
  /** 其他文字颜色*/
  textColor: string;
  /** 其他文字大小*/
  textSize: number | string;
  onEnd?: () => void;
}

export default function CountDown(props: CountDownProps) {
  const {
    preffix,
    targetDate,
    startShowDays,
    bg,
    bgSize,
    numberColor,
    numberSize,
    textColor,
    textSize,
    onEnd = () => {},
    ...rest
  } = props;
  const [, formateDateRes] = useCountDown({
    targetDate,
    onEnd,
  });

  const numberStyle: CSSProperties = {
    color: numberColor,
    fontSize: numberSize,
    background: bg,
    width: bgSize,
    height: bgSize,
  };

  const textStyle: CSSProperties = {
    color: textColor,
    fontSize: textSize,
  };

  if (!targetDate) {
    return null;
  }

  // 倒计时剩余几天时才开始展示
  if (startShowDays) {
    if (formateDateRes.days > +startShowDays) {
      return null;
    }
  }

  return (
    <div {...rest} className={classNames(styles.countDown, rest.className)}>
      {preffix && (
        <span className={styles.preffix} style={textStyle}>
          {preffix}
        </span>
      )}
      {!!formateDateRes.days && (
        <>
          <span className={styles.number} style={numberStyle}>
            {formateDateRes.days}
          </span>
          <span className={styles.text} style={textStyle}>
            天
          </span>
        </>
      )}

      <span className={styles.number} style={numberStyle}>
        {formateDateRes.hours}
      </span>
      <span className={styles.text} style={textStyle}>
        :
      </span>
      <span className={styles.number} style={numberStyle}>
        {formateDateRes.minutes}
      </span>
      <span className={styles.text} style={textStyle}>
        :
      </span>
      <span className={styles.number} style={numberStyle}>
        {formateDateRes.seconds}
      </span>
    </div>
  );
}
